import { fileFormatter } from 'utils/fileFormatter/fileFormatter';

async function payloadAdapter(payload, previousTransactions = []) {
  const {
    files,
    signatureImage: LRSSignatureImage,
    signatureMethod: _signatureMethod,
    transactions: savedTransactions,
    ...rest
  } = payload;

  let signatureImage;
  let admissionLetter;
  let documentation;
  let passport;

  if (LRSSignatureImage) {
    signatureImage = fileFormatter.cleanBase64(LRSSignatureImage);
  }

  if (files?.documentation) {
    documentation = await fileFormatter.toBase64(files.documentation);
  }

  if (files?.passport) {
    passport = await fileFormatter.toBase64(files.passport);
  }

  if (files?.admissionLetter) {
    admissionLetter = await fileFormatter.toBase64(files.admissionLetter);
  }

  const transactions = [...previousTransactions, ...savedTransactions];

  return {
    ...rest,
    signatureImage,
    ...(documentation && { documentation }),
    ...(passport && { passport }),
    ...(admissionLetter && { admissionLetter }),
    transactions,
  };
}

export { payloadAdapter };
